//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'barMul',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    legend: Array,
    subtext: String,
    xAxis: Array
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      this.option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'left',
          textStyle: {
            fontSize: 14,
            marginTop: '-8px'
          }
        },
        "color": ["#2d8cf0", "#0586a1", "#5d42a5"],
        legend: {
          top: '5%',
          data: this.legend,
          textStyle: {
            color: '#000'
          }
        },
        grid: {
          containLabel: true
        },
        tooltip: {},
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        }, {
          start: 0,
          end: 50
        }],
        xAxis: {
          type: 'category',
          axisLine: {
            show: true,
            //坐标轴线
            lineStyle: {
              color: "#2d8cf0"
            }
          },
          splitLine: {
            //分隔线
            show: false,
            lineStyle: {
              color: "#2d8cf0"
            }
          },
          axisLabel: {
            //// 刻度标签
            color: "#2d8cf0",
            lineStyle: {
              fontSize: '12'
            }
          },
          data: this.xAxis
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#0a98bc'
          },
          // 刻度标签
          splitLine: {
            //// 分隔线
            show: false,
            lineStyle: {
              color: "#8494a3"
            }
          },
          //// 坐标轴线
          axisLine: {
            show: true,
            color: '#8494a3',
            lineStyle: {
              color: '#8494a3'
            }
          }
        },
        series: {
          data: value,
          type: 'bar',
          barWidth: '25'
        }
      };
      return this.option;
    },
    init: function init() {
      var _this = this;

      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      setTimeout(function () {
        _this.resize();
      });
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};